import axios from 'axios'
import Utils from '@/common/Utils'

const url = `${process.env.VUE_APP_BASEPATH}/api`
const headers = {
    'Content-Type': 'application/json'
}

export default class FactoringDocumentReviewService {
    static async update (invoices) {
        return new Promise(async (resolve, reject) => {
            try {
                headers['Authorization'] = await Utils.setLocalToken()
                let { data } = await axios.put(`${url}/factoringDocumentReview/`, invoices, { headers })
                resolve(data)
            } catch (error) {
                reject(error)
            }
        })
    }
}
